import React from "react";

export const WbEstacionamento: React.FC = () => {
    return (
        <div>
            <h3 className="text-center justify-center">
                ANEXO V - TABELA DE VAGAS PARA ESTACIONAMENTO
            </h3>

            <table className="border-collapse w-full table-auto border-2 border-black text-center justify-center">
                <thead className="border-t border-2 border-black">
                    <tr className="bg-gray-200 border">
                        <td className="border-2 border-black px-4 py-2 text-center">
                            CATEGORIA
                        </td>
                        <td className="border-2 border-black px-4 py-2 text-center">
                            TIPO
                        </td>
                        <td className="border-2 border-black px-4 py-2 text-center">
                            NÚMERO DE VAGAS PARA ESTACIONAMENTO OU GARAGEM (3 x
                            5 m CADA VAGA)
                        </td>
                    </tr>
                </thead>
                <tbody>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black" rowSpan={3}>
                            Edificações Residenciais
                        </td>
                        <td className="border-2 border-black">
                            Residência Isolada
                        </td>
                        <td className="border-2 border-black">Facultado</td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Residência Geminada
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada unidade residencial (2,50 x 4,50 m)
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Residência em Série ou Habitação Coletiva
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada unidade residencial (2,50 x 4,50 m)
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black" rowSpan={6}>
                            Edificações de Comércio Varejista
                        </td>
                        <td className="border-2 border-black">
                            Comércio de pequeno e médio porte (&lt;400 m² ){" "}
                        </td>
                        <td className="border-2 border-black">Facultado </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Comércio de grande porte (&gt;300 m² )
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 25,00 m² de área
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Centro Comercial{" "}
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 50,00m² de área destinada.
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black" rowSpan={3}>
                            Shopping Center Supermercado e Hipermercado
                        </td>
                        <td className="border-2 border-black">
                            à venda e pátio de carga e descarga com as seguintes
                            dimensões:
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            1 vaga para cada 150,00 m² de área construída; até
                            2.000,00 m² de área construída: mínimo de 150,00 m²;
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            acima de 2.000,00 m² de área construída: 150,00 m²
                            mais 150,00 m² para cada 1.000,00 m² de área
                            construída excedente.
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Edificações para Comércio Atacadista
                        </td>
                        <td className="border-2 border-black">
                            Comércio Atacadista em geral
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 500,00 m² de área construída mais 1
                            vaga para cada 50m² de cada 150 m² excedente
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Edificações para Indústria
                        </td>
                        <td className="border-2 border-black">
                            Indústria em geral{" "}
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 50,00 m² de área construída.
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black" rowSpan={3}>
                            Edificações de Prestação de Serviço
                        </td>
                        <td className="border-2 border-black">
                            Exceto para os demais usos especificados nesta
                            Tabela
                        </td>
                        <td className="border-2 border-black">Facultado</td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Oficina Mecânica e/ou Funelaria
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 500,00 m² de área construída mais 1
                            vaga para cada 50m² de cada 150 m² excedente
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Restaurante, lanchonete, boate,clube noturno,
                            discoteca, casa de, show, danceteria, café concerto,
                            salão de baile, restaurante dançante.{" "}
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 50,00 m² de área construída.
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Edificações para fins Culturais
                        </td>
                        <td className="border-2 border-black">
                            Auditório, Teatro, Anfiteatro, Cinema, Salão de
                            Exposições, Biblioteca e Museu.
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 12,50 m² de área destinada aos
                            espectadores.
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black" rowSpan={2}>
                            Edificações para fins Recreativos e Esportivos
                        </td>
                        <td className="border-2 border-black">
                            Clube Social/Esportivo, Ginásio de Esportes,
                            Estádio, Academia.
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 12,50 m² de área construída.
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Cancha Poliesportiva{" "}
                        </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 25,00 m² de área construída.
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Edificações para fins Religiosos
                        </td>
                        <td className="border-2 border-black">
                            Templo, Capela, Casa de Culto e Igreja{" "}
                        </td>
                        <td className="border-2 border-black">Facultado </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black" rowSpan={3}>
                            Edificações para fins Educacionais
                        </td>
                        <td className="border-2 border-black">Ensino básico</td>
                        <td className="border-2 border-black">
                            Até 100,00 m² de área construída, será facultado;
                            Acima de 100,00 m² de área construída: -Área
                            administrativa: 1 vaga a cada 80,00 m² de área
                            construída; Ônibus: 30% da área destinada a salas de
                            aula; Será obrigatória canaleta interna, para
                            embarque e desembarque de veículos, com largura
                            mínima de 2,50 m e com área de acumulação (canaleta
                            de espera) na proporção de 5,00 m para cada 100,00
                            m² de área destinada a salas de aula, até 400,00 m²
                            e 5,00 m para cada 200,00 m² de área excedente.
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Ensino Médio <br />
                            Profissionalizante em geral
                        </td>
                        <td className="border-2 border-black">
                            Até 100,00 m² de área construída será facultado;
                            Acima de 100,00 m² de área construída: Área
                            administrativa: 1 vaga para cada 80,00 m² de área
                            construída e 1 vaga para cada 50,00 m² de área
                            destinada a sala de aula;
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Escolas de Artes e Ofícios Ensino não seriado
                        </td>
                        <td className="border-2 border-black">
                            Até 100,00 m² de área construída será facultado;
                            Acima de 100,00 m² de área construída: Área
                            administrativa: 1 vaga para cada 80,00 m² de área
                            construída e 1 vaga para cada 25,00 m² de área
                            destinada a sala de aula.{" "}
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">Alojamento </td>
                        <td className="border-2 border-black">Hotéis </td>
                        <td className="border-2 border-black">
                            1 vaga para cada 3 unidades de alojamento.{" "}
                        </td>
                    </tr>
                    <tr className="border-2 border-black">
                        <td className="border-2 border-black">
                            Entidades Financeiras
                        </td>
                        <td className="border-2 border-black">Bancos </td>
                        <td className="border-2 border-black">Facultado.</td>
                    </tr>
                </tbody>
            </table>
        </div>
    );
};
